import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { formatCurrency } from 'js/services/Format';
import TokenDashboardStore from 'js/stores/pages/AdminDashboardPage/TokenDashboardStore';
import LoadingSpinner from '../../LoadingSpinner';

import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import Pagination from '../../DashPanel/Pagination';
import Search from '../../DashPanel/Search';
import Title from '../../DashPanel/Title';
import DropMenu from '../../DashPanel/DropMenu';
import Controls from '../../DashPanel/Controls';

import Status from './Status';
import Link from './Link';
import GotoItem from './GotoItem';
import Date from './Date';
import { default as LinkTitle } from './Title';
import Price from './Price';
import Image from './Image';
import NotFound from './NotFound';

@observer
export default class Dashboard extends Component {
  tokenList = TokenDashboardStore.create({ page: parseInt(this.props['*']) || 1 });

  constructor(props) {
    super(props);
    this.tokenList.load();
  }

  componentDidUpdate() {
    this.tokenList.setPage(this.props['*']);

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('f') && urlParams.has('q')) {
      this.tokenList.setQueryParams({
        field: urlParams.get('f'),
        query: urlParams.get('q'),
      });
    }
  }

  render() {
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>Tokens</Title>
          <Controls>
            <Search model={this.tokenList} options={{ title: 'Title', price: 'Price', alias: 'Item ID' }} />
            <Pagination model={this.tokenList} />
          </Controls>
        </Header>

        <Content>
          {this.tokenList.isLoading ? (
            <LoadingSpinner />
          ) : this.tokenList.tokens.length ? (
            <div>
              {this.tokenList.tokens.map(token => (
                <Link to={`token/${token.alias}`} key={token.alias}>
                  <Image src={token.image} />
                  <Date>{token.created_at}</Date>
                  <LinkTitle>
                    {token.title} (<Price>{formatCurrency(token.price)}</Price>
                    {token.location ? `, ${token.location}` : ''})
                  </LinkTitle>
                  <Status>
                    <div>{token.human_status}</div>
                  </Status>
                  <GotoItem />
                </Link>
              ))}
            </div>
          ) : (
            <NotFound>No tokens found</NotFound>
          )}
        </Content>
      </DashPanel>
    );
  }
}
